import { getCleaningAuditSession } from "views/app-views/cleaningAudit/cleaningAuditAuth";
import { getLaundryAuditSession } from "views/app-views/laundryAudit/laundryAuditAuth";
import { getPeriodicalSession } from "views/app-views/workScheduler/periodicalAuth";
import { getEducationSession } from "views/app-views/employeeConnect/educationAuth";

// Each in-app module needs a two-step login (MyM handoff, then the module's
// own auto-login) before its first data call: two ~1s round trips. Starting
// those in the background shortly after the app opens means a module's
// first screen only waits for its own data. The sessions are cached and
// reused by the modules (and re-run if a different user signs in).
const SESSION_BY_NAV_KEY = {
  "cleaning-audit": getCleaningAuditSession,
  "laundry-audit": getLaundryAuditSession,
  "work-scheduler": getPeriodicalSession,
  "employee-connect": getEducationSession,
};

const PREWARM_DELAY_MS = 1500;

// navKeys: the module nav entries this user can see.
export const prewarmModuleSessions = (navKeys) => {
  const timer = setTimeout(() => {
    navKeys.forEach((key) => {
      const getSession = SESSION_BY_NAV_KEY[key];
      // A failure here is retried when the module is opened.
      if (getSession) getSession().catch(() => {});
    });
  }, PREWARM_DELAY_MS);
  return () => clearTimeout(timer);
};
